import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"
script.__scopeId = "data-v-12bafc9a"

export default script